import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

// Plan partenaire : fonctionnalité hors du compte de démonstration (pas d'upsell).
@Component({
    selector: 'app-demo-account',
    templateUrl: './demo-account.component.html',
    styleUrls: ['./demo-account.component.scss']
})
export class DemoAccountComponent {

    constructor(public dialogRef: MatDialogRef<DemoAccountComponent>) {
    }

    onCloseClick(): void {
        this.dialogRef.close(false);
    }
}
